import React from 'react';
import { ContainerStyle } from "@src/apps/Footer/Main/Main.styles";

const Main = (props) => {
    const { footerInfo } = props;

    return (<ContainerStyle>
        <footer className="footer">
            <div className="page-footer-section">
                <p>{footerInfo?.CopyrightText}</p>
                <p id='link-info'>
                    <a href={footerInfo?.contactURL}>{footerInfo?.Contact}</a>
                    <span className="separator">|</span>
                    <a href={footerInfo?.privacyURL}>{footerInfo?.Privacy}</a>
                    <span className="separator">|</span>
                    <a href={footerInfo?.termsOfUseURL}>{footerInfo?.TermsOfUse}</a>
                </p>
            </div>
        </footer>
    </ContainerStyle>);
}
export default Main;